console.log("API URL:", import.meta.env.VITE_API_URL);
console.log("Mode:", import.meta.env.MODE);